export const initialState = {
  searchTerm: '',
  filteredConversations: [],
};
